// extracted by mini-css-extract-plugin
export default {"container":"doc_3mQ2b"};